<div class="flex flex-col gap-2" [attr.data-testid]="'attribute-two-stage-' + testIdKey()">
  @if (readonly()) {
    <div
      class="flex flex-wrap items-center gap-x-4 gap-y-1 text-sm"
      [attr.data-testid]="'attribute-two-stage-readonly-' + testIdKey()"
    >
      @if (capabilityLabelKey(); as capabilityLabelKey) {
        <span>
          <span class="text-xs text-gray-500">
            {{ 'provider.tenderResponse.twoStage.capability.label' | transloco }}:
          </span>
          {{ capabilityLabelKey | transloco }}
        </span>
      }
      @if (provisioningLabelKey(); as provisioningLabelKey) {
        <span>
          <span class="text-xs text-gray-500">
            {{ 'provider.tenderResponse.twoStage.provisioning.label' | transloco }}:
          </span>
          {{ provisioningLabelKey | transloco }}
        </span>
      }
      <span>
        <span class="text-xs text-gray-500">
          {{ 'provider.tenderResponse.twoStage.factor.label' | transloco }}:
        </span>
        <span class="font-semibold" [attr.data-testid]="'attribute-factor-' + testIdKey()">
          @if (displayedFactor(); as displayedFactor) {
            {{ displayedFactor | appNumber: '1.3-3' }}
          } @else if (displayedFactor() === 0) {
            {{ 0 | appNumber: '1.3-3' }}
          } @else {
            –
          }
        </span>
      </span>
    </div>
  } @else {
    @let capabilityDescription = capabilityDescriptionKey();
    @let provisioningDescription = provisioningDescriptionKey();
    <div class="flex items-center gap-3">
      <div
        [pTooltip]="capabilityDescription ? (capabilityDescription | transloco) : ''"
        [tooltipDisabled]="!capabilityDescription"
        tooltipPosition="bottom"
      >
        <app-options-select
          label="provider.tenderResponse.twoStage.capability.label"
          [options]="capabilityOptions()"
          [value]="capabilityValue()"
          (valueChange)="onCapabilityChange($event)"
          [disabled]="disabled()"
          placeholder="provider.tenderResponse.twoStage.capability.placeholder"
          [testId]="'attribute-capability-' + testIdKey()"
          styleClass="w-56"
        />
      </div>
      <div
        [pTooltip]="provisioningDescription ? (provisioningDescription | transloco) : ''"
        [tooltipDisabled]="!provisioningDescription"
        tooltipPosition="bottom"
      >
        <app-options-select
          label="provider.tenderResponse.twoStage.provisioning.label"
          [options]="provisioningOptions()"
          [value]="provisioningValue()"
          (valueChange)="onProvisioningChange($event)"
          [disabled]="disabled()"
          placeholder="provider.tenderResponse.twoStage.provisioning.placeholder"
          [testId]="'attribute-provisioning-' + testIdKey()"
          styleClass="w-56"
        />
      </div>
      <div class="flex items-center gap-1 whitespace-nowrap">
        <span class="text-xs text-gray-500">
          {{ 'provider.tenderResponse.twoStage.factor.label' | transloco }}
        </span>
        <span
          class="text-base font-semibold"
          [attr.data-testid]="'attribute-factor-' + testIdKey()"
        >
          @if (displayedFactor(); as displayedFactor) {
            {{ displayedFactor | appNumber: '1.3-3' }}
          } @else if (displayedFactor() === 0) {
            {{ 0 | appNumber: '1.3-3' }}
          } @else {
            –
          }
        </span>
        @if (showsSingleStageHint()) {
          <i
            class="pi pi-exclamation-triangle text-yellow-500"
            [pTooltip]="
              'provider.tenderResponse.twoStage.singleStageHint'
                | transloco: {score: singleStageScore()}
            "
            tooltipPosition="bottom"
            [attr.data-testid]="'attribute-single-stage-hint-' + testIdKey()"
          ></i>
        }
      </div>
    </div>
  }
</div>
